module.exports = "<div uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{'z-index': 1040 + (index &amp;&amp; 1 || 0) + index*10}\" before-open-modal=\"before-open-modal\" class=\"cui-modal-backdrop\"></div>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/adapters/ui.bootstrap.modal/backdrop.template.jade
// module id = 25
// module chunks = 0 1